import { ApolloProvider } from 'react-apollo';
import { BrowserRouter as Router } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ApolloClient from 'apollo-boost';
import React from 'react';

import './assets/global-styles.css';

import { ClientStateProvider } from 'ClientState';

import Auth from 'utils/auth';
import Routes from './routes';

const client = new ApolloClient({
  uri: process.env.REACT_APP_API_SERVER_URI,
  request: operation => {
    operation.setContext(context => ({
      headers: {
        ...context.headers,
        authorization: Auth.token(),
      },
    }));
  },
});

const App = () => (
  <React.Fragment>
    <Helmet>
      <title>Client Dashboard | Envy Labs</title>
    </Helmet>
    <ApolloProvider client={client}>
      <ClientStateProvider>
        <Router>
          <Routes />
        </Router>
      </ClientStateProvider>
    </ApolloProvider>
  </React.Fragment>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js